<template>
  <div class="ListenButton"> 
    <div class="Button" @click="onClick()">{{ trans('GLOBAL.listen') }}</div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {
  name: 'ListenButton',
  methods:{
    onClick() {
      this.$parent.onListen()
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ListenButton  
  position relative
  width 100%
  height 14%
  border-top 1px solid transparent
  border-bottom 1px solid transparent
  display flex
  justify-content center
  align-items flex-end

</style>


